(() => {
  const ROOT_SELECTOR = '.js-news-swiper-root';
  const DESKTOP_MIN_WIDTH = 1024;

  const createOptions = (root, slideCount) => ({
    slidesPerView: 1,
    spaceBetween: 16,
    speed: 450,
    allowTouchMove: slideCount > 1,
    watchSlidesProgress: true,
    slidesPerGroup: 1,
    centeredSlides: false,
    centeredSlidesBounds: false,
    navigation: {
      nextEl: root.querySelector('.js-news-next'),
      prevEl: root.querySelector('.js-news-prev'),
    },
    pagination: {
      el: root.querySelector('.js-news-pagination'),
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 1.25,
        spaceBetween: 14,
      },
      1024: {
        // Desktop: one-card-width step; next card snaps to first position.
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        slidesPerGroupAuto: false,
        spaceBetween: 16,
      },
    },
  });

  const initRoot = (root) => {
    if (!root || root._newsSwiper) return;
    if (typeof window.Swiper === 'undefined') return;

    const swiperEl = root.querySelector('.js-news-swiper');
    if (!swiperEl) return;

    const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
    if (slideCount < 1) return;

    root._newsSwiper = new window.Swiper(swiperEl, createOptions(root, slideCount));
    updateDesktopOffset(root._newsSwiper);
  };

  const updateDesktopOffset = (swiper) => {
    if (!swiper) return;

    const isDesktop = window.matchMedia(`(min-width: ${DESKTOP_MIN_WIDTH}px)`).matches;
    if (!isDesktop) {
      if (swiper.params.slidesOffsetAfter !== 0) {
        swiper.params.slidesOffsetAfter = 0;
        swiper.update();
      }
      return;
    }

    const firstSlide = swiper.slides?.[0];
    const wrapperWidth = swiper.width || swiper.el?.clientWidth || 0;
    const slideWidth = firstSlide?.offsetWidth || 0;
    const gap = Number(swiper.params.spaceBetween) || 0;
    const trailingOffset = Math.max(0, wrapperWidth - slideWidth - gap);

    if (swiper.params.slidesOffsetAfter !== trailingOffset) {
      swiper.params.slidesOffsetAfter = trailingOffset;
      swiper.update();
    }
  };

  const destroyRoot = (root) => {
    if (!root?._newsSwiper) return;
    try {
      root._newsSwiper.destroy(true, true);
    } catch (_) {}
    root._newsSwiper = null;
  };

  const scan = () => document.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (!event.target?.querySelectorAll) return;
    event.target.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      destroyRoot(root);
      initRoot(root);
    });
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (!event.target?.querySelectorAll) return;
    event.target.querySelectorAll(ROOT_SELECTOR).forEach(destroyRoot);
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      updateDesktopOffset(root?._newsSwiper);
    });
  });
})();
